import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import useEventFilters from './useEventFilters'
import { useProducts } from '../../../hooks'

/**
 * Emit a contentSearched event when search results are loaded for analytics purposes
 * @param {Object} options
 * @param {Object} options.event - The event definition
 * @param {Object} options.filters - The search filters
 * @param {Object} options.rest - Any additional properties to be added to the event payload
 */
const useContentSearchedEvent = ({ event, filters, ...rest }) => {
  const { hasContentHubAccess } = useProducts()

  const [contentSearched] = useEvent([{ eventName: 'contentSearched' }])
  const { getEventFilters } = useEventFilters()

  useEventsOnViewLoad(() => {
    if (!hasContentHubAccess) return

    const listener = event.registerAdhocOnSuccessListener(({ payload }) => {
      const { term, total } = payload
      const { types, keywords, time } = getEventFilters(filters)
      contentSearched.trigger({ term, total, types, keywords, time, ...rest })
    })

    return () => {
      event.unregisterAdhocListener(listener, 'onSuccess')
    }
  }, [hasContentHubAccess, event, contentSearched, filters, rest, getEventFilters])
}

export default useContentSearchedEvent
